/** Rectangular golden bales with cross-bound twine and individually cut straw edges. */
import { checkEnvelope, checkScope, el, n, partGroup } from '../../svg';
import type { PieceArt, PieceRecipe, ResolvedPalette } from '../../contract';
import { amount, grainRng, ground, line } from './machinerySvg';
export interface HayBalesParams { readonly bales: number }
export type HayBalesRecipe = PieceRecipe<'mill.hay_bales.v1', HayBalesParams>;
export const HAY_BALES_FRAME = { w: 120, h: 70 } as const;
export const MILL_HAY_BALES: HayBalesRecipe = {
  schema: 'hush.asset-recipe.v1', id: 'mill.hay_bales.default.v1', generatorId: 'mill.hay_bales.v1',
  seed: 20071009, paletteId: 'millrace_amber', params: { bales: 3 },
};
export function buildHayBales(recipe: HayBalesRecipe, p: ResolvedPalette, scope: string): PieceArt {
  checkEnvelope(recipe, MILL_HAY_BALES.generatorId); checkScope(scope);
  const bales = amount(recipe.params.bales, 'bales', 2, 4, true), random = grainRng(recipe), parts: string[] = [];
  let straw = '';
  const slots = [{ x: 8, y: 38 }, { x: 62, y: 39 }, { x: 25, y: 13 }, { x: 71, y: 14 }];
  for (const i of [2, 3, 0, 1].filter(index => index < bales)) {
    const { x, y } = slots[i], width = i === 3 ? 37 : 45;
    straw += el('path', { d: `M${x} ${y + 2}L${x + 3} ${y}H${x + width - 2}L${x + width} ${y + 4}V${y + 24}L${x + width - 4} ${y + 26}H${x + 2}Z`, fill: p.paperBase, stroke: p.woodShadow, 'stroke-width': 1 })
      + el('path', { d: `M${x + 2} ${y + 3}H${x + width - 3}V${y + 6}H${x + 2}Z`, fill: p.paperLight });
    for (let j = 0; j < 26; j++) {
      const sx = x + 2 + random(`straw.x.${i}.${j}`) * (width - 8), sy = y + 7 + random(`straw.y.${i}.${j}`) * 17;
      straw += line(sx, sy, sx + 3 + random(`straw.l.${i}.${j}`) * 4, sy - 0.7, j % 3 ? p.woodLight : p.paperLight, 0.7);
    }
    for (const dx of [width * 0.25, width * 0.73]) straw += el('path', { d: `M${n(x + dx)} ${y}Q${n(x + dx - 2)} ${y + 13} ${n(x + dx)} ${y + 26}`, fill: 'none', stroke: p.woodShadow, 'stroke-width': 2.2 })
      + line(x + dx + 0.8, y + 1, x + dx + 0.8, y + 24, p.woodLight, 0.8);
  }
  const body = partGroup(parts, 'hay-ground', ground(120, 70, p)) + partGroup(parts, 'bound-hay-bales', straw);
  return { frame: HAY_BALES_FRAME, body, anchors: { support: { x: 60, y: 70 } }, parts, openings: [] };
}
